import React, { useEffect } from 'react';

const Tidio: React.FC = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//code.tidio.co/nwell1yvleclot2osq9jny62xa9bhg1d.js';
        script.async = true;
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return null;
};

export default Tidio;
